import * as React from "react";
import { Modal, Typography, Card, Box, Grid, IconButton, Icon } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CancelIcon from "../../../icons/cancelIcon.svg";
import { BankAccountDTO } from "@inosio/payments-sdk";

const useStyles = makeStyles({
  modalContainer: {
    background: "#FFFFFF",
    boxShadow: "none",
    borderRadius: "24px",
  },
  bankDetail: {
    fontFamily: "Work Sans !important",
    fontStyle: "normal !important",
    fontWeight: "600 !important",
    fontSize: "18px !important",
    lineHeight: "22px !important",
    color: "#000000 !important",
    textAlign: "center",
  },
  detailsText: {
    fontFamily: "Work Sans !important",
    fontStyle: "normal !important",
    fontWeight: "400 !important",
    fontSize: "18px !important",
    lineHeight: "21px !important",
    color: "#14142B !important",
  },
});

interface BankAccountDetailsModalProps {
  open: boolean;
  data: BankAccountDTO | undefined;
  closeCallback: () => void;
}

export default function BankAccountDetailsModal(props: BankAccountDetailsModalProps) {
  const classes = useStyles();
  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "16px",
    width:'520px',
    height:'555px',
    pointerEvents: "auto",
    borderRadius: '24px',
    outline: 'none',
  };

  return (
    <div className={`${classes.modalContainer}`}>
      <Modal
        open={props.open}
        onClose={() => props.closeCallback()}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        BackdropProps={{
          invisible: false,
        }}
      >
        <Card sx={style}>
          <>
            <Grid container>
              <Grid item xs={2}></Grid>
              <Grid item xs={8}>
                <Typography id="bank-detail" className={classes.bankDetail} sx={{ mt: 1 }}>
                  Bank Detail
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <IconButton sx={{ ml: "30px" }} onClick={() => props.closeCallback()}>
                  <Icon>
                    <img src={CancelIcon} alt="" width={24} height={24} />
                  </Icon>
                </IconButton>
              </Grid>
            </Grid>

            <Box sx={{ textAlign: "center", mt: 3 }}>
              <Typography className={classes.detailsText}>{props.data?.NickName || ''}</Typography>
            </Box>

            <Grid container sx={{ px: "30px", mt: 2 }}>
              <Grid item xs={7} sx={{ mt: 1.5 }}>
                <Typography className={classes.detailsText}>{`Account Number`}</Typography>
              </Grid>
              <Grid item xs={5} sx={{ mt: 1.5 }}>
                <Typography className={classes.detailsText}>{props.data?.AccountLastFour || ''}</Typography>
              </Grid>
              <Grid item xs={7} sx={{ mt: 1.5 }}>
                <Typography className={classes.detailsText}>{`Routing Number`}</Typography>
              </Grid>
              <Grid item xs={5} sx={{ mt: 1.5 }}>
                <Typography className={classes.detailsText}>{props.data?.RoutingNumber || ''}</Typography>
              </Grid>
              <Grid item xs={7} sx={{ mt: 1.5 }}>
                <Typography className={classes.detailsText}>{`Bank Name`}</Typography>
              </Grid>
              <Grid item xs={5} sx={{ mt: 1.5 }}>
                <Typography className={classes.detailsText}>{props.data?.BankName || ''}</Typography>
              </Grid>
            </Grid>
          </>
        </Card>
      </Modal>
    </div>
  );
}
